import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import EntryStatusBoard from "@/pages/home/components/EntryStatusBoard";
import StayFoundSteps from "@/pages/home/components/StayFoundSteps";
import HotTopicWall from "@/pages/home/components/HotTopicWall";
import NewsFeed from "@/pages/home/components/NewsFeed";
import TipsSection from "@/pages/home/components/TipsSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <EntryStatusBoard />
        <StayFoundSteps />
        <HotTopicWall />
        <NewsFeed />
        <TipsSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}